const historyLogsActions = {
  HISTORY_LOGS_SET: 'HISTORY_LOGS_SET',
  HISTORY_LOGS_ADD: 'HISTORY_LOGS_ADD'
};
export default historyLogsActions;
